import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HandleError } from '../../components/common/utils/handleError.component';
import { SessionStorageService } from "ngx-webstorage";
import { ClienteLogin, ClienteXCiudad, Cliente, ClienteVAM } from '../login/cliente_login';
import { timeInterval } from 'rxjs/operator/timeInterval';
import { fail } from 'assert';
import { checkNoChangesNode } from '@angular/core/src/view/view';
import { CompleterService, CompleterData, CompleterItem } from 'ng2-completer';
import { LocalData } from 'ng2-completer/services/local-data';
import { FormulariosService } from './formularios.service';
import { UtilService } from '../../components/common/utils/util.service';
import { ConsultaCarpeta, Carpeta, Archivo, CarpetasArchivo, BuscaArchivos } from '../../components/common/utils/entities/util_entity';
import { ConsultarUsuarioMasivos } from '../../components/common/utils/consultarUsuarioMasivos';


const swal = require("sweetalert2");
declare var jQuery: any;

@Component({
    selector: 'formularios',
    templateUrl: 'formularios.template.html'
})

export class FormulariosComponent implements OnInit {
    usuarioMasivos: Cliente;
    usuarioEmpresa: ClienteXCiudad;
    usuario: ClienteLogin;
    consulta: ConsultaCarpeta;
    carpetas: Carpeta[];
    showLoader: string;
    showLoaderTabla: string;
    archivos: Archivo[];
    filterQuery: string;
    banderaMasivos: boolean;
    usuarioMasivosSeleccionado: Cliente;
    rutaArmada: string;
    segundoNivel: boolean;
    tercerNivel: boolean;
    carpetasArchivos: CarpetasArchivo;
    carpetasArchivosCli: CarpetasArchivo;
    banderaAseg: boolean;
    datosBusqueda: BuscaArchivos;
    archivosXAseguradora: Archivo[];
    ocultaArchCli: boolean;


    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private handleError: HandleError,
        private formulariosService: FormulariosService,
        public utilsService: UtilService,
        public sesionStorageService: SessionStorageService,
        private completerService: CompleterService,
        private consultarMasivo: ConsultarUsuarioMasivos
    ) {
        this.carpetas = new Array<Carpeta>();
        this.archivos = new Array<Archivo>();
        this.usuario = new ClienteLogin();
        this.usuarioMasivosSeleccionado = new Cliente();
        this.banderaMasivos = false;
        this.segundoNivel = false;
        this.tercerNivel = false;
        this.ocultaArchCli = true;
        this.rutaArmada = "";
        this.carpetasArchivos = new CarpetasArchivo();
        this.carpetasArchivosCli = new CarpetasArchivo(),
            this.banderaAseg = false;
        this.archivosXAseguradora = new Array<Archivo>();
        this.datosBusqueda = new BuscaArchivos();
    }
    ngOnInit() {
        this.consulta = new ConsultaCarpeta();
        this.showLoader = "sk-loading";


        try {
            this.usuario = JSON.parse(this.sesionStorageService.retrieve("usuario"));
            if (this.sesionStorageService.retrieve("usermasivos") != null) {
                this.usuarioMasivosSeleccionado = JSON.parse(this.sesionStorageService.retrieve("usermasivos"));
            }
        } catch (e) {
            this.usuario = this.sesionStorageService.retrieve("usuario");
            if (this.sesionStorageService.retrieve("usermasivos") != null) {
                this.usuarioMasivosSeleccionado = this.sesionStorageService.retrieve("usermasivos");
            }
        }

        try {
            this.usuarioEmpresa = JSON.parse(this.sesionStorageService.retrieve("usuarioempresa"));
        } catch (e) {
            this.usuarioEmpresa = this.sesionStorageService.retrieve("usuarioempresa");
        }
        if (this.usuario.Masivos != null && this.usuario.Masivos != undefined) {
            if (this.usuario.Masivos != null && this.usuario.Masivos != undefined && this.usuarioMasivosSeleccionado == null) {
                this.usuarioMasivos = this.usuario.Masivos[0];

                //this.sesionStorageService.store("usermasivos", JSON.stringify(this.usuarioMasivos));
                if (this.usuario.Masivos != null)
                    this.consultarMasivo.iniciarUsuarioMasivo();
                this.banderaMasivos = true;
            } else {
                this.usuarioMasivos = this.usuarioMasivosSeleccionado;

                if (this.usuario.Masivos != null && this.usuario.Masivos != undefined)
                    this.consultarMasivo.iniciarUsuarioMasivo();
                this.banderaMasivos = true;
            }
        }

        if (this.usuarioEmpresa != null) {
            this.consulta.Carpeta = 1;
            this.consulta.Empresa = this.usuarioEmpresa;
            this.consulta.Masivos = null;
            this.banderaMasivos = false;
            this.datosBusqueda.Carpeta = 1;
            this.datosBusqueda.CodigoCiudad = this.consulta.Empresa.Ciudad;
            this.datosBusqueda.CodigoCliente = this.consulta.Empresa.CodigoCliente;

        }
        if (this.usuarioMasivos != null) {
            this.consulta.Carpeta = 1;
            this.consulta.Empresa = null;
            this.consulta.Masivos = this.usuarioMasivos;
            this.banderaMasivos = true;
            this.datosBusqueda.Carpeta = 1;
            this.datosBusqueda.CodigoCiudad = this.consulta.Masivos.Ciudad;
            this.datosBusqueda.CodigoCliente = this.consulta.Masivos.CodigoCliente;


        }

        if (this.usuario.VAM != null && this.usuario.VAM != undefined && this.usuario.VAM.length > 0) {
            this.consulta.Cedula = this.usuario.Cedula;
            this.consulta.Vam = new Array<ClienteVAM>();
            this.consulta.Vam = this.usuario.VAM;
            this.consulta.Carpeta = 1;
            this.banderaMasivos = true;
        } else {
            this.consulta.Cedula = null;
        }

        this.formulariosService.getCarpetasPorSegmento(this.consulta).subscribe(
            result => {
                this.carpetas = result;
                this.carpetas.forEach(a => {
                    a.ClaseIcono = "fa-folder";
                });
                this.showLoader = "";
            },
            error => {
                this.handleError.redirectUrl(error);
                this.showLoader = "";
            });
    }


    verSubCarpetas(carpeta: Carpeta) {
        this.rutaArmada = "";
        this.rutaArmada = "1_Segmentos\\" + carpeta.Codigo + "_" + carpeta.Nombre;
        this.segundoNivel = true;
        this.tercerNivel = false;
        this.showLoaderTabla = "sk-loading";
        this.carpetas.forEach(a => {
            a.ClaseIcono = "fa-folder"
        });
        carpeta.ClaseIcono = "fa-folder-open-o";
        this.consulta.CodSegmento = carpeta.Codigo;

        this.formulariosService.getCarpetasAsegArchivosPorSegmento(this.consulta).subscribe(
            result => {
                this.carpetasArchivos.Carpetas = result.Carpetas;
                this.carpetasArchivos.Archivos = result.Archivos;
                if (this.carpetasArchivos.Carpetas.length == 0)
                    this.banderaAseg = true;
                else
                    this.banderaAseg = false


                this.carpetasArchivos.Carpetas.forEach(a => {
                    a.ClaseIcono = "fa-folder";
                });
                this.carpetasArchivos.Archivos.forEach(a => {
                    if (a.Extension == "pdf")
                        a.TipoIcono = " fa-file-pdf-o";

                    if (a.Extension == "xls" || a.Extension == "xlsx")
                        a.TipoIcono = " fa-file-excel-o";

                    else
                        a.TipoIcono = "fa-file-text-o";

                    a.RestoRuta = this.rutaArmada;
                });
                this.showLoaderTabla = "";
            },
            error => {
                this.handleError.redirectUrl(error);
                this.showLoaderTabla = "";
            }
        );
    }
    verArchivosXAseguradora(carpeta: Carpeta) {
        this.carpetasArchivosCli.Archivos = new Array<Archivo>();
        this.tercerNivel = true;
        this.showLoaderTabla = "sk-loading";

        this.carpetasArchivos.Carpetas.forEach(a => {
            a.ClaseIcono = "fa-folder"
        });
        carpeta.ClaseIcono = "fa-folder-open-o";
        this.datosBusqueda.Carpeta = 1;
        this.datosBusqueda.RestoRuta = this.rutaArmada + "\\" + carpeta.Codigo + "_" + carpeta.Nombre;
        this.datosBusqueda.CodigoSegmento= this.consulta.CodSegmento;
        this.datosBusqueda.CodigoCliente= carpeta.CodigoCliente;
        this.datosBusqueda.CodigoCiudad= carpeta.CodigoCiudad;


        this.formulariosService.getCarpetasArchivosPorCarpeta(this.datosBusqueda).subscribe(
            result => {
                this.archivosXAseguradora = result;

                this.utilsService.getCarpetasAsegArchivosPorCliente(this.datosBusqueda).subscribe(
                  carpArchi => {
                      this.carpetasArchivosCli = carpArchi;
                      this.carpetasArchivosCli.Archivos = carpArchi.Archivos;

                      if (this.carpetasArchivosCli.Archivos.length > 0) {
                          this.ocultaArchCli = false;
                          this.carpetasArchivosCli.Archivos.forEach(a => {
                              if (a.Extension == "pdf")
                                  a.TipoIcono = " fa-file-pdf-o";

                              if (a.Extension == "xls" || a.Extension == "xlsx")
                                  a.TipoIcono = " fa-file-excel-o";

                              else
                                  a.TipoIcono = "fa-file-text-o";


                          });
                      }
                      else
                          this.ocultaArchCli = true;

                      this.showLoaderTabla = "";
                  },
                  error => {
                      this.handleError.redirectUrl(error);
                      this.showLoaderTabla = "";
                  }
              );
                this.showLoaderTabla = "";
            },
            error => {
                this.handleError.redirectUrl(error);
                this.showLoaderTabla = "";
            }
        );




    }

    verArchivos(carpeta: Carpeta) {
        this.showLoaderTabla = "sk-loading";
        this.carpetas.forEach(a => {
            a.ClaseIcono = "fa-folder"
        });
        carpeta.ClaseIcono = "fa-folder-open-o";
        this.formulariosService.getArchivosFormularios(carpeta).subscribe(
            result => {
                this.archivos = result;
                this.showLoaderTabla = "";
            },
            error => {
                this.handleError.redirectUrl(error);
                this.showLoaderTabla = "";
            }
        );
    }
    descargar(archivo: Archivo) {
        this.formulariosService.getArchivo(archivo).subscribe(
            result => {
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.className = "hidden"
                let fileBlob = result.blob();
                let blob = null;
                if (archivo.Extension.toUpperCase() == "PDF") {
                    blob = new Blob([fileBlob], {
                        type: 'application/pdf'
                    });
                }
                if (archivo.Extension.toUpperCase() == "XLSX") {
                    blob = new Blob([fileBlob], {
                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    });
                }
                let url = window.URL.createObjectURL(blob);
                a.href = url;
                if (archivo.Extension.toUpperCase() == "PDF") {
                    a.download = archivo.Nombre + ".pdf";
                }
                if (archivo.Extension.toUpperCase() == "XLSX") {
                    a.download = archivo.Nombre + ".xlsx";
                }
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    if (archivo.Extension.toUpperCase() == "XLSX") {
                        window.navigator.msSaveOrOpenBlob(blob, archivo.Nombre + ".xlsx");
                    } else {
                        window.navigator.msSaveOrOpenBlob(blob, archivo.Nombre + ".pdf");
                    }
                }
                else {
                    a.click();
                    window.URL.revokeObjectURL(url);
                }
                this.showLoader = "";
            },
            error => {
                this.handleError.redirectUrl(error);
            }
        );
    }
}



// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/formularios/formularios.component.ts